import { render } from "./MainScreen.vue?vue&type=template&id=28d953d8"
import script from "./MainScreen.vue?vue&type=script&lang=js"
export * from "./MainScreen.vue?vue&type=script&lang=js"
script.render = render

export default script